/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './helpModal.tpl.html';

/**
 * Module for the help modal.
 */
angular
  .module('shared.modal', [])
  /**
   * Help Modal controller.  Controller for the helpModal.tpl.html template.
   */
  .controller('HelpModalCtrl', function ($scope, $uibModalInstance, $filter, authFactory, accountUtils) {
    $scope.actor = { username: '' };
    $scope.orgName = '';
    $scope.orgId = '';

    accountUtils.getOrgInfo().then(
      function (orgObj) {
        // Set the values for the support modal.
        $scope.orgId = orgObj.sfId;
        $scope.orgName = orgObj.name;
      },
      function () {
        $scope.$emit(ALERT_EVENTS.ERROR.eventName, $filter('i18n')('LOAD_ORG_DATA_FAILED'));
      }
    );

    const getUsername = function (data) {
      if (!data) {
        return '';
      }

      if (data.displayName && data.loginType && data.loginType.scope === 'EXTERNAL') {
        return data.displayName;
      }

      return data.username;
    };

    authFactory.getSignedRequest().then((actor) => {
      $scope.actor = actor;
      $scope.supportModalUsername = getUsername($scope.actor);
    });

    $scope.helpModalText = $filter('i18n')('HELP_MODAL_TEXT');
    $scope.cancel = function () {
      $uibModalInstance.close();
    };
  });
